/**
 * Used on a Filterrific form, using Turbostream
 *  * All form inputs will initiate a form submission when changed
 *  * Text input will allow a delay before form submission
 *
 * Accepts values:
 *  * (optional) text-input-delay - time delay (in ms) after text input changes to submit the form
 *
 * Use like so when creating a form:
 *
 *  = form_for_filterrific @filterrific,
 *      data: { controller: "forms--filterrific-form",
 *        forms__filterrific_form_text_input_delay_value: "1000"} do |f|
 *
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    textInputDelay: { type: Number, default: 500 },
  };

  get currentForm() {
    return this.element;
  }

  processRequest() {
    var url = this.currentForm.getAttribute("action"),
      formData = new FormData(this.currentForm),
      params = new URLSearchParams(formData);

    if (url.indexOf("?") < 0) {
      url += "?" + params;
    } else {
      url += "&" + params;
    }

    Turbo.navigator.delegate.adapter.showProgressBar();

    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((r) => r.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
        var newUrl = new URL(url, window.location.origin);
        var currentState = history.state || {};
        history.replaceState(
          { ...currentState, turbo_stream: true },
          document.title,
          newUrl,
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        Turbo.navigator.delegate.adapter.progressBar.hide();
      });
  }

  submitFilterForm() {
    this.processRequest();
  }

  connect() {
    this.boundListeners = [];

    // Add change event handler to all Filterrific filter inputs.
    if (this.currentForm) {
      this.boundSubmit = () => this.submitFilterForm();
      this.boundTrigger = () => {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.submitFilterForm();
        }, this.textInputDelayValue);
      };

      this.currentForm.querySelectorAll("select").forEach((input) => {
        if (input.id.includes("filterrific")) {
          input.addEventListener("change", this.boundSubmit);
          this.boundListeners.push([input, "change", this.boundSubmit]);
        }
      });

      this.element.querySelectorAll("input, textarea").forEach((input) => {
        if (input.id.includes("filterrific")) {
          input.addEventListener("input", this.boundTrigger, true);
          this.boundListeners.push([input, "input", this.boundTrigger, true]);
        }
      });
    }
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer);

    this.boundListeners?.forEach(([el, event, handler, capture]) => {
      el.removeEventListener(event, handler, !!capture);
    });
    this.boundListeners = [];
  }
}
